import { ActionContext, ActionTree } from "vuex";
import { IPermissionsState } from "@/core/interfaces/permissionsState.interface";
import PermissionsService from "@/modules/Permissions/services/permissions.service";
import { AGENT_SUB_ROLES } from "@/core/enums/AGENT_SUB_ROLES";
import { StoreState } from "@/store/type";
import { IPermissionCategory } from "@/core/interfaces/permission.interface";

const actions: ActionTree<IPermissionsState, StoreState> = {
  async fetchPermissions(
    context: ActionContext<IPermissionsState, StoreState>,
    agentType: AGENT_SUB_ROLES,
  ) {
    try {
      context.commit("fetchingPermissions", true);
      const permissionsService = new PermissionsService();
      const response = await permissionsService.getAll(agentType);
      const categories = (response.data || []) as IPermissionCategory[];
      context.commit("fetchPermissionsSuccess", categories);
    } catch (err) {
      context.commit("fetchingPermissions", false);
    }
  },
};

export default actions;
